// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select_Select__DZNZg","isSelected":"Select_isSelected__NigzF","Select__Placeholder":"Select_Select__Placeholder__Ywt1W"};